import axiosInstance from '@/utils/axiosInstance.js'
import MSAPIInstance from '@/services/MSAPI/MSAPIInstance.js'
import MSAPIConstants from '@/services/MSAPI/MSAPIConstants'
import SERVICES from '@/utils/servicesUtil.js'
import Qs from 'qs'

const getChannels = (organizationId) => axiosInstance.get(`${SERVICES.CAMPAIGN_CHANNELS}/${organizationId}`)

// Métodos campaign
const getCampaign = (organizationId, campaignId) => axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}`)
const deleteCampaign = (organizationId, campaignId) => axiosInstance.delete(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}`)
const cancelCampaign = (organizationId, campaignId) => axiosInstance.patch(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/cancel`)
const getCampaigns = (organizationId, $body) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}`, {
    params: $body,
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
  })
const postCampaign = (organizationId, body) => axiosInstance.post(`${SERVICES.CAMPAIGN}/${organizationId}`, body)
const patchCampaign = (organizationId, campaignId, body) => axiosInstance.patch(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}`, body)
const patchRunCampaign = (organizationId, campaignId) => axiosInstance.patch(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/run`)
const patchSendCampaign = (organizationId, campaignId) => axiosInstance.patch(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/send`)
const getCampaignResult = (organizationId, campaignId) => axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/result`)
const getCampaignSummaryBalance = (organizationId, campaignId) => axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/balance`)
const getOrganizationCampaignMetrics = (organizationId) => axiosInstance.get(`${SERVICES.CAMPAIGN_ENGAGEMENT}/${organizationId}`)

// TODO: Revisar os filtros, pois até o mommento desta implementação, ainda não foram definidos
const getCampaignResume = (organizationId, scheduleType, scheduleId, type, filters) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/schedulings/${scheduleType}/${scheduleId}/${type}`, {
    params: filters,
  })

const getCampaignResumeDownload = (organizationId, scheduleType, scheduleId, type, filters) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/schedulings/${scheduleType}/${scheduleId}/${type}/download`, {
    params: filters,
    responseType: 'blob',
  })

// Novos Métodos campanha
// const patchCampaingNew = (campaignId,body) => axiosInstance.patch(`${SERVICES.CAMPAIGN}/${campaignId}/withjsonobject`, body)
const emailSchedulingTest = (organizationId, body, campaignId) =>
  axiosInstance.post(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/emailschedulingtest`, body)
const smsSchedulingTest = (organizationId, body, campaignId) =>
  axiosInstance.post(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/smsschedulingtest`, body)
const hasAudience = (organizationId) => axiosInstance.get(`${SERVICES.AUDIENCE}/${organizationId}/hasaudience`)

function paramsSerializer(params) {
  const serializedParams = Object.keys(params)
    .map((key) => {
      if (Array.isArray(params[key])) {
        return `${key}=${params[key].join(',')}`
      }
      return `${key}=${params[key]}`
    })
    .join('&')

  return serializedParams
}

const getCampaignsTransactions = (organizationId, $channel, $body) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_TRANSACTIONS}/${organizationId}/${$channel}`, {
    params: $body,
    paramsSerializer: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
  })

const getCampaignResults = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/totalResult`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultsByPeriod = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/${campaignId}/totalResultByPeriod`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultEmailClicks = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/clicks`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultEmailClicksDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/clicks/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultEmailBounces = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/bounced`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultEmailBouncesDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/bounced/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultEmailUnsubscribes = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/unsubscribes`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultEmailUnsubscribesDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/unsubscribes/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultEmailUniqueOpens = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/uniqueopens`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultEmailUniqueOpensDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/email/${campaignId}/uniqueopens/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultSMSDelivered = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/delivered`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultSMSDeliveredDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/delivered/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultSMSNotDelivered = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/notdelivered`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultSMSNotDeliveredDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/notdelivered/download`, {
    params: params,
    responseType: 'blob',
  })

const getCampaignResultSMSPending = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/pending`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignResultSMSPendingDownload = (organizationId, campaignId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_RESULTS}/${organizationId}/sms/${campaignId}/pending/download`, {
    params: params,
    responseType: 'blob',
  })

const sendQuickSMSJwt = (body) => MSAPIInstance.post(`${MSAPIConstants.SMS}/sendjwt`, body)

const downloadTransactionAttachment = (organizationId, recipientId, attachmentId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_TRANSACTIONS}/${organizationId}/email/${recipientId}/attachment/${attachmentId}`, {
    params: params,
    responseType: 'blob',
  })

const getOrganizationConsumptions = (organizationId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_REPORTS}/${organizationId}/organizationconsumptions`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const downloadOrganizationConsumptions = (organizationId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_REPORTS}/${organizationId}/organizationconsumptions/download`, {
    params,
    responseType: 'blob',
  })

const getCampaignOrganizationUsers = (organizationId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN}/${organizationId}/users`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

const getCampaignChannelsWatermarks = (organizationId, params) =>
  axiosInstance.get(`${SERVICES.CAMPAIGN_CHANNELS}/${organizationId}/watermarks`, {
    params,
    paramsSerializer: (params) => paramsSerializer(params),
  })

export default {
  getChannels,

  postCampaign,
  patchCampaign,
  getCampaign,
  getCampaigns,
  patchRunCampaign,
  patchSendCampaign,
  getCampaignResult,
  getCampaignResume,
  getCampaignResumeDownload,
  deleteCampaign,
  cancelCampaign,
  getCampaignSummaryBalance,
  getOrganizationCampaignMetrics,

  emailSchedulingTest,
  smsSchedulingTest,
  hasAudience,

  getCampaignsTransactions,
  getCampaignResults,
  getCampaignResultsByPeriod,

  getCampaignResultEmailClicks,
  getCampaignResultEmailClicksDownload,
  getCampaignResultEmailBounces,
  getCampaignResultEmailBouncesDownload,
  getCampaignResultEmailUnsubscribes,
  getCampaignResultEmailUnsubscribesDownload,
  getCampaignResultEmailUniqueOpens,
  getCampaignResultEmailUniqueOpensDownload,
  getCampaignResultSMSDelivered,
  getCampaignResultSMSDeliveredDownload,
  getCampaignResultSMSNotDelivered,
  getCampaignResultSMSNotDeliveredDownload,
  getCampaignResultSMSPending,
  getCampaignResultSMSPendingDownload,

  sendQuickSMSJwt,
  downloadTransactionAttachment,

  getOrganizationConsumptions,
  downloadOrganizationConsumptions,

  getCampaignOrganizationUsers,
  getCampaignChannelsWatermarks,
}
